"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equipmentIdType = exports.edgeNodeItemType = exports.buildingItemType = exports.PwhSupplyItemType = exports.PwhPipeItemType = exports.PwhCItemType = exports.PwcPoeItemType = exports.HtgSysItemType = exports.HtgSubItemType = exports.HtgPipeItemType = exports.HtgHxItemType = exports.HtgHsItemType = exports.HtgCCItemType = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _devices = require("./devices");
var _translations = require("./translations");
var _images = require("./images");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const equipmentIdType = exports.equipmentIdType = _propTypes.default.string;
const relationsType = _propTypes.default.arrayOf(_propTypes.default.string).isRequired;
const equipmentItemType = {
  building: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  devices: _propTypes.default.arrayOf(_devices.deviceType).isRequired,
  hasimages: _images.hasimagesType,
  id: equipmentIdType.isRequired,
  thingInfoDesignation: _translations.translationValueType
};
const buildingItemType = exports.buildingItemType = _propTypes.default.shape({
  hasimages: _images.hasimagesType,
  id: equipmentIdType.isRequired,
  thingBuildingHouseNumber: _translations.translationValueType.isRequired,
  thingBuildingStreet: _translations.translationValueType.isRequired
});
const edgeNodeItemType = exports.edgeNodeItemType = _propTypes.default.shape({
  id: equipmentIdType.isRequired,
  thingInfoControlCenterComment: _translations.translationValueType.isRequired,
  thingNodeSerialNumber: _propTypes.default.string.isRequired,
  thingPDID: _propTypes.default.string.isRequired
});
const HtgCCItemType = exports.HtgCCItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  pwhSupply: relationsType,
  thingHtgCcMaterialFlow: _translations.translationValueType.isRequired,
  thingHtgCcName: _translations.translationValueType.isRequired,
  thingHtgCcNominalDiameterFlow: _translations.translationValueType.isRequired,
  thingHtgCcPumpManufacturer: _translations.translationValueType.isRequired,
  thingHtgCcPumpModel: _translations.translationValueType.isRequired,
  thingHtgCcPumpName: _translations.translationValueType.isRequired
}));
const HtgHsItemType = exports.HtgHsItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  htgCc: relationsType,
  htgHs: relationsType,
  htgHx: relationsType,
  htgSub: relationsType,
  thingHtgHsManufacturingDate: _translations.translationValueType.isRequired,
  thingHtgHsModel: _translations.translationValueType.isRequired,
  thingHtgHsNameL: _translations.translationValueType.isRequired,
  thingHtgHsPrimaryMaterial: _translations.translationValueType.isRequired,
  thingHtgHsType: _translations.translationWithIdType
}));
const HtgHxItemType = exports.HtgHxItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  htgHx: relationsType,
  htgPipe: relationsType,
  thingHtgHxHydraulicCircuit: _propTypes.default.string.isRequired,
  thingHtgHxName: _translations.translationValueType.isRequired,
  thingHtgHxNominalDiameterFlow: _translations.translationValueType.isRequired,
  thingHtgHxPumpManufacturer: _translations.translationValueType.isRequired,
  thingHtgHxPumpModel: _translations.translationValueType.isRequired,
  thingHtgHxPumpName: _translations.translationValueType.isRequired
}));
const HtgPipeItemType = exports.HtgPipeItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  thingHtgPipeName: _translations.translationValueType.isRequired
}));
const HtgSysItemType = exports.HtgSysItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  htgCc: relationsType,
  htgHs: relationsType,
  htgHx: relationsType,
  htgSup: relationsType,
  thingBoilerManufacturer: _translations.translationValueType.isRequired,
  thingBoilerManufacturingDate: _translations.translationValueType.isRequired,
  thingBoilerModel: _translations.translationValueType.isRequired,
  thingCompactSystem: _propTypes.default.bool.isRequired,
  thingHtgSysBurnerManufacturer: _translations.translationValueType.isRequired,
  thingHtgSysBurnerManufacturingDate: _translations.translationValueType.isRequired,
  thingHtgSysBurnerModel: _translations.translationValueType.isRequired,
  thingHtgSysDistrictHeatingType: _translations.translationWithIdType,
  thingHtgSysEnergySource: _translations.translationWithIdType,
  thingHtgSysHeatGenerator: _translations.translationWithIdType,
  thingHtgSysName: _translations.translationValueType.isRequired,
  thingHtgSysNominalHeatOutput: _translations.translationValueType.isRequired
}));
const HtgSubItemType = exports.HtgSubItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  htgCc: relationsType,
  htgHs: relationsType,
  htgHx: relationsType,
  thingHtgSubLocalHeatingType: _translations.translationWithIdType
}));
const PwcPoeItemType = exports.PwcPoeItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  pwhSupply: relationsType,
  thingPOEBackflushFilterManufacturer: _translations.translationValueType.isRequired,
  thingPOEBackflushFilterModel: _translations.translationValueType.isRequired,
  thingPOEBackflushFilterPresent: _propTypes.default.bool.isRequired,
  thingPOENominalDiameter: _translations.translationValueType.isRequired
}));
const PwhCItemType = exports.PwhCItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  pwhPipe: relationsType,
  thingPwhCPumpManufacturer: _translations.translationValueType.isRequired,
  thingPwhCPumpMaximumFlowRate: _translations.translationValueType.isRequired,
  thingPwhCPumpModel: _translations.translationValueType.isRequired,
  thingPwhCPumpName: _translations.translationValueType.isRequired,
  thingPwhCPumpPressureZone: _translations.translationValueType.isRequired
}));
const PwhPipeItemType = exports.PwhPipeItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  thingPwhPipeName: _translations.translationValueType.isRequired
}));
const PwhSupplyItemType = exports.PwhSupplyItemType = _propTypes.default.shape(_objectSpread(_objectSpread({}, equipmentItemType), {}, {
  pwhC: relationsType,
  pwhSupply: relationsType,
  thingPwhSupplyCapacity: _translations.translationValueType.isRequired,
  thingPwhSupplyDeviceType: _translations.translationWithIdType,
  thingPwhSupplyManufacturer: _translations.translationValueType.isRequired,
  thingPwhSupplyModel: _translations.translationValueType.isRequired,
  thingPwhSupplyName: _translations.translationValueType.isRequired
}));